import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'colorStatusCode',
    standalone: false
})
export class ColorStatusCodePipe implements PipeTransform {

  static statuses = [
    {
      code: 1,
      color: '#7c3f7c',
      colorName: 'COLORSCODE.LILA.COLOR_NAME',
      name: 'COLORSCODE.LILA.NAME',
      description: 'COLORSCODE.LILA.SHORT_DESCRIPTION'
    },
    {
      code: 2,
      color: '#df000f',
      colorName: 'COLORSCODE.RED.COLOR_NAME',
      name: 'COLORSCODE.RED.NAME',
      description: 'COLORSCODE.RED.SHORT_DESCRIPTION'
    },
    {
      code: 3,
      color: '#ffcb00',
      colorName: 'COLORSCODE.YELLOW.COLOR_NAME',
      name: 'COLORSCODE.YELLOW.NAME',
      description: 'COLORSCODE.YELLOW.SHORT_DESCRIPTION'
    },
    {
      code: 4,
      color: '#4a90e2',
      colorName: 'COLORSCODE.BLUE.COLOR_NAME',
      name: 'COLORSCODE.BLUE.NAME',
      description: 'COLORSCODE.BLUE.SHORT_DESCRIPTION'
    },
    {
      code: 5,
      color: '#000000',
      colorName: 'COLORSCODE.BLACK.COLOR_NAME',
      name: 'COLORSCODE.BLACK.NAME',
      description: 'COLORSCODE.BLACK.SHORT_DESCRIPTION'
    },
    {
      code: 6,
      color: '#89ff89',
      colorName: 'COLORSCODE.LIGHT_GREEN.COLOR_NAME',
      name: 'COLORSCODE.LIGHT_GREEN.NAME',
      description: 'COLORSCODE.LIGHT_GREEN.SHORT_DESCRIPTION'
    },
    {
      code: 7,
      color: '#00d700',
      colorName: 'COLORSCODE.GREEN.COLOR_NAME',
      name: 'COLORSCODE.GREEN.NAME',
      description: 'COLORSCODE.GREEN.SHORT_DESCRIPTION'
    },
    {
      code: null,
      color: '#b3b9bd',
      colorName: 'COLORSCODE.GREY.COLOR_NAME',
      name: 'COLORSCODE.GREY.NAME',
      description: 'COLORSCODE.GREY.SHORT_DESCRIPTION'
    },
  ];

  loadStatuses = [
    {
      code: 0,
      color: '#b3b9bd',
      percentage: '',
      description: 'ANALYZE.NO_DATA',
    },
    {
      code: 1,
      color: '#870001',
      percentage: '0%',
      description: 'ANALYZE.RATED_POWER',
    },
    {
      code: 2,
      color: '#dc3545',
      percentage: '20%',
      description: 'ANALYZE.RATED_POWER',
    },
    {
      code: 3,
      color: '#cca200',
      percentage: '40%',
      description: 'ANALYZE.RATED_POWER',
    },
    {
      code: 4,
      color: '#ffcb00',
      percentage: '60%',
      description: 'ANALYZE.RATED_POWER',
    },
    {
      code: 5,
      color: '#00d700',
      percentage: '80%',
      description: 'ANALYZE.RATED_POWER',
    },
    {
      code: 6,
      color: '#009700',
      percentage: '100%',
      description: 'ANALYZE.RATED_POWER',
    },
    {
      code: 9,
      color: '#b3b9bd',
      percentage: 'ANALYZE.NO_DATA'
    }
  ];

  tempStatuses = [
    {
      code: 0,
      color: '#00d700',
      percentage1: '',
      percentage2: '',
      descriptionPart1: 'ANALYZE.NO_PROBLEM',
      descriptionPart2: '',
    },
    {
      code: 1,
      color: '#ffcb00',
      percentage1: '10% ',
      percentage2: ' 20% ',
      descriptionPart1: 'COMMON.TO',
      descriptionPart2: 'ANALYZE.ABOVE_AVERAGE',
    },
    {
      code: 2,
      color: '#ff8000',
      percentage1: '20% ',
      percentage2: ' 30% ',
      descriptionPart1: 'COMMON.TO',
      descriptionPart2: 'ANALYZE.ABOVE_AVERAGE',
    },
    {
      code: 3,
      color: '#df000f',
      percentage1: '30% ',
      percentage2: '',
      descriptionPart1: 'ANALYZE.ABOVE_AVERAGE',
      descriptionPart2: '',
    },
    {
      code: 4,
      color: '#6c757d',
      percentage1: '',
      percentage2: '',
      descriptionPart1: 'ANALYZE.NO_DATA',
      descriptionPart2: '',
    },
    {
      code: 5,
      color: '#000000',
      percentage1: '',
      percentage2: '',
      descriptionPart1: 'ANALYZE.OUT_OF_BOUNDS',
      descriptionPart2: '',
    },
    {
      code: 9,
      color: '#6c757d',
      percentage1: '',
      percentage2: '',
      descriptionPart1: 'ANALYZE.NO_DATA',
      descriptionPart2: '',
    }
  ];



productionColors = [
  {
    code: 0,
    color: '#cc0000',
    percentage1: '<20% ',
    percentage2: '',
    descriptionPart1: '',
    descriptionPart2: '',
  },
  {
    code: 1,
    color: '#ff8000',
    percentage1: '40% ',
    percentage2: '',
    descriptionPart1: '',
    descriptionPart2: '',
  },
  {
    code: 2,
    color: '#f4b800',
    percentage1: '60%',
    percentage2: '',
    descriptionPart1: '',
    descriptionPart2: '',
  },
  {
    code: 3,
    color: '#a6ff00',
    percentage1: '80%',
    percentage2: '',
    descriptionPart1: '',
    descriptionPart2: '',
  },
  {
    code: 4,
    color: '#00d700',
    percentage1: '100%',
    percentage2: '',
    descriptionPart1: '',
    descriptionPart2: '',
  },
  {
    code: 9,
    color: '#b3b9bd',
    percentage1: '',
    percentage2: '',
    descriptionPart1: 'ANALYZE.NO_DATA',
    descriptionPart2: '',
  }
];


  transform(value: any, key: any, type?:string): any {
    let statusFound;
    let statuses: any;
    if (type === 'load' || type === 'efficiency') {
      statuses = this.loadStatuses;
    } else if (type === 'tempStatus' || type === 'temp-status') {
      statuses = this.tempStatuses;
    } else if (type === 'production') {
      statuses = this.productionColors;
    } else if (type === 'revenues') {
      statuses = this.productionColors;
    } else {
      statuses = ColorStatusCodePipe.statuses;
    }

    if (key === 'code') {
      key = 'description'
      statusFound = statuses.find(status => status.color === value);
      if (statusFound === undefined) {
        return undefined;
      }
    } else {
      statusFound = statuses.find(status => status.code === value);
      if (statusFound === undefined) {
        statusFound = statuses[statuses.length - 1];
      }
    }

    return statusFound[key];
  }

  transformLoadStatus(value: any, key: any, byCode?: boolean): any {
    let statusFound;
		if (!byCode) {
    	statusFound = this.loadStatuses.find(status => status.color === value);
		} else {
			statusFound = this.loadStatuses.find(status => status.code === value);
		}
    if (!statusFound || !statusFound[key]) {
      return 'ANALYZE.NO_DATA';
    }
    return statusFound[key];
  }

  transformTempStatus(value: any, byCode?: boolean): any {
    let statusFound;
		if (!byCode) {
			statusFound = this.tempStatuses.find(status => status.color === value);
		} else {
			statusFound = this.tempStatuses.find(status => status.code === value);
		}
    return statusFound;
  }

  transformTempStatusByValue(val:number,isOutOfBounds:boolean): any {
    let valCode: number;
    if ((val <= 0 || val > 0) && val < 0.1) {
      valCode = 0;
    } else if (val >= 0.1 && val < 0.2) {
      valCode = 1;
    } else if (val >= 0.2 && val < 0.3) {
      valCode = 2;
    } else if (val >= 0.3 && val < 9) {
      valCode = 3;
    } else {
      valCode = 4;
    }
    if (isOutOfBounds) valCode = 5;
    return this.transformTempStatus(valCode, true);
  }

}
